<template>
  <section v-if="activeProperty" class="row">
    <card>
      <language-selector />
      <div class="d-flex flex-wrap">
        <div class="col-12 mb-4">
          <div class="row">
            <div class="col-12">
              <h3>Editing {{ activeProperty.label }}</h3>
              <button class="btn btn-sm btn-primary" @click="viewAll">
                View all properties
              </button>
              <button
                class="btn btn-sm btn-primary ml-1"
                @click="saveProperty(activeProperty)"
              >
                Save
              </button>
            </div>
          </div>
        </div>
        <div class="col-6 mb-4">
          <div class="row">
            <div class="col-6 mb-4">
              Label
              <input
                type="text"
                class="form-control form-control-lg"
                v-model="activeProperty.label"
                placeholder="Lot 1001"
              />
            </div>
            <div class="col-6 mb-4">
              Display Label
              <localised-field-indicator />
              <input
                type="text"
                class="form-control form-control-lg"
                v-model="activeProperty.displayLabel[activeLanguage.code]"
                placeholder="Allotment 1001"
              />
            </div>
            <div class="col-6 mb-4">
              Status
              <select class="form-control" v-model="activeProperty.status">
                <option value="Available">Available</option>
                <option value="Builder Lots">Builder Lots</option>
                <option value="Coming Soon">Coming Soon</option>
                <option value="On Hold">On Hold</option>
                <option value="Sold">Sold</option>
                <option value="Not Released">Not Released</option>
                <option value="Unassigned">Unassigned</option>
              </select>
            </div>
            <div class="col-6 mb-4">
              Price
              <input
                type="text"
                class="form-control"
                :value="activeProperty.price"
                @input="
                  event =>
                    (activeProperty.price = event.target.value.replace(
                      /[^0-9.]/g,
                      ''
                    ))
                "
              />
            </div>
            <div class="col-6 mb-4">
              Price Label
              <localised-field-indicator />
              <input
                type="text"
                class="form-control"
                v-model="activeProperty.priceLabel[activeLanguage.code]"
              />
            </div>
            <div class="col-4 mb-4">
              Price Override
              <info-box class="ml-1">
                This field can be used to override the price coming from the
                client CRM with having to worry about it being updated/changed
                by client CRM updates.
              </info-box>
              <input
                type="text"
                class="form-control"
                :value="activeProperty.priceOverride"
                @input="
                  event =>
                    (activeProperty.priceOverride = event.target.value.replace(
                      /[^0-9.]/g,
                      ''
                    ))
                "
              />
            </div>

            <div class="col-2 mb-4">
              Price Suffix
              <info-box class="ml-1">
                Add a suffix to the end of the price override
              </info-box>
              <input
                type="text"
                class="form-control"
                v-model="activeProperty.priceSuffix"
              />
            </div>

            <div class="col-12 mb-4">
              Description
              <localised-field-indicator />
              <ck-editor
                id="propertyDescription"
                v-model="activeProperty.description[activeLanguage.code]"
                :dir="activeLanguage.rtl ? 'rtl' : 'ltr'"
                :key="activeLanguage.code"
                :language="activeLanguage.code"
              />
            </div>

            <div class="col-12 mb-4">
              Address
              <input
                type="text"
                class="form-control"
                v-model="activeProperty.address"
              />
            </div>

            <div class="col-6 mb-4">
              Frontage
              <input
                type="number"
                class="form-control"
                step=".1"
                v-model="activeProperty.frontage"
              />
            </div>
            <div class="col-6 mb-4">
              Depth
              <input
                type="number"
                class="form-control"
                step=".1"
                v-model="activeProperty.depth"
              />
            </div>
            <div class="col-6 mb-4">
              Size
              <input
                type="number"
                class="form-control"
                step=".1"
                v-model="activeProperty.size"
              />
            </div>
            <div class="col-12 mb-4">
              View/Outlook Label
              <localised-field-indicator />
              <input
                class="form-control"
                type="text"
                v-model="activeProperty.viewLabel[activeLanguage.code]"
              />
            </div>

            <div class="col-12 mb-4">
              View/Outlook Images
              <input-asset
                v-model="activeProperty.viewImages"
                :multiple="true"
              />
            </div>

            <div class="col-12 mb-4">
              iFrames
              <input-key-value-pairs
                class="form-control form-control-lg"
                key-label="label"
                value-label="url"
                v-model="activeProperty.iframes"
              ></input-key-value-pairs>
            </div>

            <div class="col-12 mb-4">
              Is visible on webfeed?<br />
              <toggle-button
                v-model="activeProperty.isVisibleOnWebfeed"
                :color="{ checked: '#28a745', unchecked: '#b8b8b8' }"
                :sync="true"
                :width="30"
                :height="20"
              />
            </div>

            <div class="col-12 mb-4">
              Is Display Home?<br />
              <toggle-button
                v-model="activeProperty.isDisplayHome"
                :color="{ checked: '#28a745', unchecked: '#b8b8b8' }"
                :sync="true"
                :width="30"
                :height="20"
              />
            </div>

            <div class="col-12 mb-4" v-if="activeProperty.isDisplayHome">
              Display Home Hours
              <localised-field-indicator /><br />
              <textarea
                class="form-control"
                v-model="activeProperty.displayHomeHours[activeLanguage.code]"
              />
            </div>
          </div>
        </div>

        <div class="col-6 mb-4">
          <div class="row">
            <div class="col-12 mb-4">
              Select a Turnkey Dwelling
              <input-single-select
                v-model="activeProperty.dwellingId"
                label="Dwellings"
                :options="dwellingOptions"
              />
            </div>
            <div class="col-12 mb-4">
              Select Suitable Dwellings
              <input-multi-select
                v-model="activeProperty.suitableDwellingIds"
                label="Dwellings"
                :options="dwellingOptions"
              />
            </div>
          </div>
        </div>
      </div>
    </card>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import CkEditor from "@/components/CKEditor";
import InfoBox from "@/components/InfoBox";
import InputAsset from "@/components/InputAsset";
import InputKeyValuePairs from "@/components/InputKeyValuePairs";
import InputMultiSelect from "@/components/InputMultiSelect";
import InputSingleSelect from "@/components/InputSingleSelect";

export default {
  components: {
    CkEditor,
    InfoBox,
    InputAsset,
    InputKeyValuePairs,
    InputMultiSelect,
    InputSingleSelect
  },

  data() {
    return {
      activePropertyId: null,
      propertiesFilterText: "",
      filterStatuses: [],
      filterActiveStates: []
    };
  },

  computed: {
    ...mapGetters(["activeLanguage", "properties", "dwellings"]),

    activeProperty() {
      return this.properties.find(
        property => property._id === this.activePropertyId
      );
    },

    dwellingOptions() {
      return this.dwellings.map(dwelling => {
        return {
          label: dwelling.label,
          value: dwelling._id
        };
      });
    }
  },

  created() {
    this.$store.dispatch("FETCH_ASSETS");
    this.$store.dispatch("FETCH_PROPERTIES");
    this.$store.dispatch("FETCH_DWELLINGS");
  },

  mounted() {
    this.activePropertyId = this.$route.params.id;
  },

  methods: {
    viewAll() {
      this.$router.go(-1);
    },

    saveProperty(property) {
      this.$store.dispatch("SAVE_PROPERTY", property);
      this.viewAll();
    }
  }
};
</script>
